import dayjs from 'dayjs';

import { OrderHistoryFilter } from '../modals/OrderHistoryFilter';
import { OrderHistoryFilterContext } from '../modals/OrderHistoryFilterContext';

export const initializeFilterState = (filters: OrderHistoryFilterContext) => {
  const initialFilter: OrderHistoryFilter = {
    customerIds: filters.customerIds || [],
    soldThrough: filters.soldThrough || [],
    OrdStatus: filters.OrdStatus || [],
    poDateFrom: filters.poDateFrom ? dayjs(filters.poDateFrom) : null,
    poDateTo: filters.poDateTo ? dayjs(filters.poDateTo) : null,
  };
  return initialFilter;
};

// Check if filters have been modified or not
export const checkIfFiltersChanged = (filterObj: OrderHistoryFilter): boolean => {
  return (
    filterObj.customerIds.length > 0 ||
    filterObj.soldThrough.length > 0 ||
    filterObj.OrdStatus.length > 0 ||
    filterObj.poDateFrom !== null ||
    filterObj.poDateTo !== null
  );
};
